import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import type { RecruitmentShowPeopleProps as Props } from './types';
import type { CompanyPerson } from '../../../types/recruitmentShow';
import { getCompanyPeople } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [companyPeople, setCompanyPeople] = useState<CompanyPerson[]>([])

  useEffect(() => {
    const request = async () => {
      try {
        const response = await getCompanyPeople(props.companyId);
        setCompanyPeople(response.companyPeople);
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.companyId]);

  useEffect(() => {
    const $companyMemberSlick = $('.js-recruitment-people')
    if (!$companyMemberSlick.hasClass('slick-initialized')) {
      $companyMemberSlick.slick({
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        centerMode: false,
        centerPadding: '0',
        variableWidth: true,
        autoplay: false,
        prevArrow: '<div class="recruitment__show__company__slider--prev"></div>',
        nextArrow: '<div class="recruitment__show__company__slider--next"></div>',
        responsive: [
          {
            breakpoint: 780,
            settings: {
              arrows: false,
              centerMode: false,
              slidesToShow: 3
            }
          }
        ]
      })
    }
  }, [companyPeople])

  return (
    <Presentation
      companyPeople={companyPeople}
      noIconImg={props.noIconImg}
      isStopped={props.isStopped}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
      isPreview={props.isPreview}
    />
  );
};
